import {useDialogContext} from "../../dialogs/hooks/useDialogContext";
import {FullScreenEditorDialogState} from "../types/FullScreenEditorDialogState";

export const useFullScreenEditorDialog = () => useDialogContext<FullScreenEditorDialogState>('fullscreen-editor');
